import { computed, inject, watch } from 'vue'
import { useVuelidateValidation } from '@/composables/app/useVuelidateValidation'
import { useVuelidate } from '@vuelidate/core'

export function useProcedureBlockValidator ({ validations = [], state }) {
  const procedure = inject('procedure')
  const procedure_execution = inject('procedure_execution')

  const { getValidationArgs } = useVuelidateValidation()

  const data = computed(() => ({ procedure: procedure.value, procedure_execution: procedure_execution.value }))

  const validationArgs = computed(() => getValidationArgs({ validations, data }))

  const validator = computed(() => v.value.$dirty ? v$.value : v.value)

  const v = useVuelidate(validationArgs, state, { $scope: 'procedure' })
  const v$ = useVuelidate(validationArgs, state)

  watch(validationArgs, () => v$.value.$touch(), { immediate: true })

  return {
    validationArgs,
    validator,
    v
  }
}